export default __webpack_public_path__ + "static/media/landing-travel.23198ca6.webp";